import { useZustand } from '../hooks/useZustand'

export function calculateAvailableOptions(
    statements,
    currentRecalculateFilter
) {
    // Extract unique sentiments from statements
    const sentimentsSet = new Set()
    const tagsSet = new Set()
    const topicsSet = new Set()
    const topicsInfo = useZustand.getState().topics

    statements.forEach(statement => {
        if (
            statement.sentiment &&
            !currentRecalculateFilter.sentiments.includes(statement.sentiment)
        ) {
            sentimentsSet.add(statement.sentiment)
        }
        // Tags
        if (Array.isArray(statement.tags)) {
            statement.tags.forEach(tag => {
                if (!currentRecalculateFilter.tags.includes(tag)) {
                    tagsSet.add(tag)
                }
            })
        }
        // Topics

        if (
            (statement.topCommunity && statement.topCommunity !== 'none') ||
            statement.topCommunity === 0 ||
            statement.topCommunity === '0'
        ) {
            topicsSet.add(parseInt(statement.topCommunity))
        }
        if (
            (statement.topOfCommunity && statement.topOfCommunity !== 'none') ||
            statement.topOfCommunity == 0 ||
            statement.topOfCommunity == '0'
        ) {
            topicsSet.add(parseInt(statement.topOfCommunity))
        }
    })

    // Fallback to default options if none found
    const sentiments =
        sentimentsSet.size > 0
            ? Array.from(sentimentsSet)
            : ['Positive', 'Negative', 'Neutral']
    const selectedTopicNames = currentRecalculateFilter.topics.map(
        topic => topic.aiName
    )
    const sortedEnrichedTopics = topicsInfo.filter(
        topic =>
            topicsSet.has(topic.id) &&
            !selectedTopicNames.includes(topic.aiName)
    )

    return {
        sentiments,
        tags: Array.from(tagsSet),
        topics: sortedEnrichedTopics,
        // topics: sortedEnrichedTopics.length === 1 ? [] : sortedEnrichedTopics,
    }
}
